import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Row, Col, Card, CardBody, Input, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { setShippingAddress } from '../../CartActions';
import { getLoggedUser } from '../../../User/UserActions';
import { getLanguagePath } from '../../../Intl/IntlActions';

import UserLoginForm from '../../../User/components/auth/UserLoginForm';
import UserRegisterAndAddressForm from '../../../User/components/form/UserRegisterAndAddressForm';
import AddressEditForm from '../../../Address/components/form/AddressEditForm';

class CartShipping extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginTab: 'new',
        };
    }

    handleRegister = (user, shippingAddress, invoiceAddress) => {
        this.props.dispatch(setShippingAddress(shippingAddress));
        this.props.goToNextStep();
    }

    render() {
        const { user, addresses } = this.props;
        return (
            <Fragment>
                <Card>
                    <CardBody>
                        {
                            user
                                ? <UserRegisterAndAddressForm closeForm={this.handleRegister} />
                                : (
                                    <Fragment>
                                        <Row noGutters className="bg-light text-center text-primary">
                                            <Col className={classnames('position-relative', 'p-2', this.state.loginTab === 'new' && 'bg-secondary text-white')} onClick={() => this.setState({ loginTab: 'new' })}>
                                                {this.state.loginTab === 'new' && <span className="position-absolute text-secondary" style={{ bottom: '-1.2em', left: '49%' }}><FontAwesome name="caret-down" size="2x" /></span>}
                                                <span className="special-font text-lg"><FormattedMessage id="userCustomerNewTitle" defaultMessage="New customer?" /></span><br />
                                                <span><FormattedMessage id="userCustomerNewSubTitle" defaultMessage="Contact details and customer account" /></span>
                                            </Col>
                                            <Col className={classnames('position-relative', 'p-2', this.state.loginTab === 'registered' && 'bg-secondary text-white')} onClick={() => this.setState({ loginTab: 'registered' })}>
                                                {this.state.loginTab === 'registered' && <span className="position-absolute text-secondary" style={{ bottom: '-1.2em', left: '49%' }}><FontAwesome name="caret-down" size="2x" /></span>}
                                                <span className="special-font text-lg"><FormattedMessage id="userCustomerRegisteredTitle" defaultMessage="Already customer" /></span><br />
                                                <span><FormattedMessage id="userCustomerRegisteredSubTitle" defaultMessage="Connectez-vous" /></span>
                                            </Col>
                                        </Row>
                                        <div className="py-4">
                                            {
                                                this.state.loginTab === 'new'
                                                    ? <UserRegisterAndAddressForm closeForm={this.handleRegister} />
                                                    : <UserLoginForm redirect={getLanguagePath('/cart/shipping', this.props.intl.locale)} hideRegisterButton />
                                            }
                                        </div>
                                    </Fragment>
                                )

                        }
                    </CardBody>
                </Card>
            </Fragment>
        );
    }
}

function mapStateToProps(store, props) {
    const user = getLoggedUser(store);
    return {
        user,
    };
}

CartShipping.defaultProps = {
    user: null,
    addresses: [],
};

CartShipping.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object,
    addresses: PropTypes.arrayOf(PropTypes.object),
    goToNextStep: PropTypes.func.isRequired,
};


export default connect(mapStateToProps)(injectIntl(CartShipping));
